module.exports = __webpack_public_path__ + "static/media/logo-santanamaranhao.ec8108ba.png";